import { loadRegalAuthProfile, type RegalAuthContextValue } from "App/main/RegalAuthContext";

import type { AuthState } from "Types/Auth";

type AuthStateTypeOrEmpty = AuthState | Record<PropertyKey, never>;

/**
 * DO NOT IMPORT THIS. JUST FOR TESTS
 */
export const __getInitialState = (): AuthState | null => getInitialState();

function getInitialState(): AuthState | null {
    const regalAuth: RegalAuthContextValue | undefined = loadRegalAuthProfile();
    if (!regalAuth) {
        return null;
    }

    return {
        isAuthenticated: true,
        brand: regalAuth.brand.slug,
        user: {
            brand: regalAuth.brand.slug,
            email: regalAuth.user.email,
            family_name: regalAuth.user.lastName,
            given_name: regalAuth.user.firstName,
            name: `${regalAuth.user.firstName} ${regalAuth.user.lastName}`,
            sub: regalAuth.user.oktaUserId,
        },
    };
}

export const authState: AuthStateTypeOrEmpty = getInitialState() || {};

export const brandSlugFromAuth = () => authState.brand || "";
